import { FCX, ID } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { ComponentProps, ReactNode } from "react";
import TooltipWrapper from "@components/TooltipWrapper/TooltipWrapper";

export type SettingsValue = {
    id: ID;
    title: ReactNode;
    tooltip?: ReactNode;
}

export type SettingsItem = {
    title: ReactNode;
    value?: ReactNode;
    values?: SettingsValue[];
    isLoader?: boolean;
}

const AiResultSettings: FCX<{
    settings: SettingsItem[];
}> = ({
    settings,
    className,
    testId,
}) => {
    return (
        <div
            className={cn(
                "AiResultSettings",
                className
            )}
            data-testid={testId ?? "blockAiResultSettings"}
        >
            <span
                className="AiResultSettings__title"
                data-testid="textAiResultSettingsTitle"
            >Settings</span>
            <div
                className="AiResultSettings__items"
                data-testid="textAiResultSettingsItems"
            >{
                settings.map(({ title, values, value, isLoader }, itemIndex) => (
                    <div
                        key={`SettingItem${itemIndex}`}
                        className={cn(
                            'AiResultSettings__item',
                            !isLoader && "appears-left",
                            `del-${itemIndex}`,
                        )}
                        data-testid={`blockAiResultSettingsItem${itemIndex}`}
                    >
                        <span
                            className="AiResultSettings__item-title"
                            data-testid={`textAiResultSettingsItemTitle${itemIndex}`}
                        >
                            {title}
                        </span>
                        {!!value && (
                            <span
                                className="AiResultSettings__item-value"
                                data-testid={`textAiResultSettingsItemValue${itemIndex}`}
                            >
                                {value}
                            </span>
                        )}
                        {!!values && values.map((v) => (
                            <TooltipWrapper
                                thumbnail={(
                                    <span
                                        className="AiResultSettings__item-value"
                                        data-testid={`textAiResultSettingsItemValue${v.id}`}
                                    >
                                        {v.title}
                                    </span>
                                )}
                                tooltipProps={{
                                    place: "left",
                                }}
                            >
                                {v.tooltip}
                            </TooltipWrapper>
                        ))}
                    </div>
                ))
            }</div>
        </div>
    );
};

export type AiResultSettingsProps = ComponentProps<typeof AiResultSettings>;

export default AiResultSettings;